import ListGradingScales from "./List";
import { AdministrationServicePath, GRADING_SCALES } from "utils/constants";
import EditGradingScales from "./Edit";
import CreateGradingScales from "./Create";
import permissions from "app/permissions";
import GradeIcon from "@mui/icons-material/Grade";

export const resources = {
  isMenu: true,
  recordRepresentation: "name",
  icon: <GradeIcon />,
  name: AdministrationServicePath + GRADING_SCALES,
  title: "Скали за оценяване",
  list: <ListGradingScales />,
  create: <CreateGradingScales />,
  createPermission: permissions.canCreateGradingScales,
  edit: <EditGradingScales />,
  editPermission: permissions.canUpdateGradingScales,
  permission: permissions.canPreviewGradingScales,
};
